import React from 'react';
import PropTypes from 'prop-types';
import { MdCamera } from 'react-icons/md';
import * as constants from '../../constants';
import ToolbarButton from './toolbar-button';

export default function ToolbarScreenshotButton(_ref, _ref2) {
    var mode = _ref.mode;
    var translator = _ref2.translator;


    var imageBrowserDownload = function imageBrowserDownload(imageUri) {
        var fileOutputLink = document.createElement('a');

        var filename = 'output' + Date.now() + '.png';
        filename = window.prompt('Insert output filename', filename);
        if (!filename) return;

        fileOutputLink.setAttribute('download', filename);
        fileOutputLink.href = imageUri;
        fileOutputLink.style.display = 'none';
        document.body.appendChild(fileOutputLink);
        fileOutputLink.click();
        document.body.removeChild(fileOutputLink);
    };

    var saveScreenshotToFile = function saveScreenshotToFile(event) {
        event.preventDefault();
        var canvas = document.getElementsByTagName('canvas')[0];
        imageBrowserDownload(canvas.toDataURL());
    };

    var saveSVGScreenshotToFile = function saveSVGScreenshotToFile(event) {
        event.preventDefault();

        // First of all I need the svg content of the viewer
        var svgElements = document.getElementsByTagName('svg');
        // I get the element with max width (which is the viewer)
        var maxWidthSVGElement = svgElements[0];
        for (var i = 1; i < svgElements.length; i++) {
            if (svgElements[i].width.baseVal.value > maxWidthSVGElement.width.baseVal.value) {
                maxWidthSVGElement = svgElements[i];
            }
        }

        var serializer = new XMLSerializer();

        var img = new Image();

        // I create the new canvas to draw
        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext('2d');

        // Set width and height for the new canvas
        var heightAtt = document.createAttribute('height');
        heightAtt.value = maxWidthSVGElement.height.baseVal.value;
        canvas.setAttributeNode(heightAtt);

        var widthAtt = document.createAttribute('width');
        widthAtt.value = maxWidthSVGElement.width.baseVal.value;
        canvas.setAttributeNode(widthAtt);

        ctx.fillStyle = 'white';
        ctx.fillRect(0, 0, canvas.width, canvas.height);

        img.crossOrigin = 'anonymous';
        var ser = serializer.serializeToString(maxWidthSVGElement);
        var utf8Bytes = encodeURIComponent(ser).replace(/%([0-9A-F]{2})/g, function (match, p1) {
            return String.fromCharCode('0x' + p1);
        });
        img.src = 'data:image/svg+xml;base64,' + window.btoa(utf8Bytes);

        img.onload = function () {
            ctx.drawImage(img, 0, 0, maxWidthSVGElement.width.baseVal.value, maxWidthSVGElement.height.baseVal.value);
            imageBrowserDownload(canvas.toDataURL());
        };
    };

    if ([constants.MODE_3D_FIRST_PERSON, constants.MODE_3D_VIEW].includes(mode)) {
        return React.createElement(
            ToolbarButton,
            { active: false, isTooltipVisible: false, name: 'Снимка', onClick: saveScreenshotToFile },
            React.createElement(MdCamera, null)
        );
    }

    if ([constants.MODE_IDLE, constants.MODE_2D_ZOOM_IN, constants.MODE_2D_ZOOM_OUT, constants.MODE_2D_PAN, constants.MODE_WAITING_DRAWING_LINE, constants.MODE_DRAGGING_LINE, constants.MODE_DRAGGING_VERTEX, constants.MODE_DRAGGING_ITEM, constants.MODE_DRAWING_LINE, constants.MODE_DRAWING_HOLE, constants.MODE_DRAWING_ITEM, constants.MODE_DRAGGING_HOLE, constants.MODE_ROTATING_ITEM, constants.MODE_DRAWING_AREA, constants.MODE_DRAGGING_AREA].includes(mode)) {

        return React.createElement(
            ToolbarButton,
            { active: false, isTooltipVisible: false, name: translator.t('Picture'), onClick: saveSVGScreenshotToFile },
            React.createElement(MdCamera, null)
        );
    }

    return null;
}

ToolbarScreenshotButton.propTypes = {
    mode: PropTypes.string.isRequired
};

ToolbarScreenshotButton.contextTypes = {
    translator: PropTypes.object.isRequired
};